export const INVOICE_FILE_ROLES = [
  'raw_invoice_pdf',
  'processed_pdf',
  'parsing_input',
  'misc',
  'incoming_email',
  'outgoing_email',
  'invoice_check_protocol',
] as const;
